class AbstractApiActionTypes {
  SET_INITIALIZED = "__ALIAS__/SET_INITIALIZED";
  SET_LIST = "__ALIAS__/SET_LIST";
  SET_LIST_HOVER_INDEX = "__ALIAS__/SET_LIST_HOVER_INDEX";
  SET_LIST_ORDERS = "__ALIAS__/SET_LIST_ORDERS";
  SET_LIST_SELECTED_INDEX = "__ALIAS__/SET_LIST_SELECTED_INDEX";
  SET_FILTER = "__ALIAS__/SET_FILTER";
  SET_FILTERS = "__ALIAS__/SET_FILTERS";

  constructor(alias) {
    Object.keys(this).forEach((key) => {
      this[key] = this[key].replace("__ALIAS__", alias);
    });
  }
}

export default AbstractApiActionTypes;
